import { EntityLegalType } from './../../models/entity';
import { InvestorStatus } from './../../models/investor';
export interface IRegistrationKiwiSaverEntityState {
    entityId: number;
    entityName: string;
    legalEntityType: EntityLegalType;
}
export const initialRegistrationKiwiSaverEntityState: IRegistrationKiwiSaverEntityState = null;


export interface IRegistrationKiwiSaverStatusState {
    failText: string;
    status: InvestorStatus;
}
export const initialRegistrationKiwiSaverStatusState: IRegistrationKiwiSaverStatusState = {
    failText: null,
    status: null
};


export interface RegistrationKiwiSaverState {
    kiwiSaverEntity: IRegistrationKiwiSaverEntityState;
    kiwiSaverStatus: IRegistrationKiwiSaverStatusState;
}


export const initialRegistrationKiwiSaverState: RegistrationKiwiSaverState = {
    kiwiSaverEntity: initialRegistrationKiwiSaverEntityState,
    kiwiSaverStatus: initialRegistrationKiwiSaverStatusState
};

